import React from 'react';

import { SimpleGrid } from '@vfuk/core-simple-grid';
import { Block } from '@vfuk/core-block';

import { SectionTestimonialRowProps } from './types/SectionTestimonialRow.types';
import Testimonial from './Testimonial';
import {
  HeadingContainer,
  TestimonialContainer,
  whiteCSS,
  galleryCSS,
} from './styles/SectionTestimonialRow.styles';
import Header from '../../Elements/Header';

const SectionTestimonialRow: React.FC<SectionTestimonialRowProps> = ({
  testimonials,
  heading,
  backgroundColor,
}) => {
  const backgroundCss = backgroundColor === 'white' ? whiteCSS : galleryCSS;
  const testimonialAppearance = backgroundColor === 'white' ? 'secondary' : 'primary';

  return (
    <Block paddingLevel={2} css={backgroundCss}>
      <TestimonialContainer>
        {heading && (
          <HeadingContainer>
            <Header spacingLevel={{ bottom: 8 }} content={heading} />
          </HeadingContainer>
        )}
        {testimonials && (
          <SimpleGrid
            layout={{ sm: [12], md: testimonials.length > 1 ? [6, 6] : [12] }}
            spacing={4}
            verticalAlign="stretch"
          >
            {testimonials[0] && <Testimonial {...testimonials[0]} appearance={testimonialAppearance} />}
            <SimpleGrid spacing={4} verticalAlign="stretch">
              {testimonials[1] && <Testimonial {...testimonials[1]} appearance={testimonialAppearance} />}
              {testimonials[2] && <Testimonial {...testimonials[2]} appearance={testimonialAppearance} />}
            </SimpleGrid>
          </SimpleGrid>
        )}{' '}
      </TestimonialContainer>
    </Block>
  );
};

export default SectionTestimonialRow;
